// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\utils\\\\theme.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$(),
  _s2 = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\utils\\theme.tsx");
  import.meta.hot.lastModified = "1790877538677.5134";
}
// REMIX HMR END

import { createContext, useContext, useState, useEffect, useCallback } from "react";
const ThemeContext = createContext({
  theme: "light",
  toggleTheme: () => {}
});
export function ThemeProvider({
  children
}) {
  _s();
  const [theme, setTheme] = useState("light");
  useEffect(() => {
    const stored = localStorage.getItem("theme");
    if (stored === "dark") {
      setTheme("dark");
      document.documentElement.classList.add("dark");
    }
  }, []);
  const toggleTheme = useCallback(() => {
    const html = document.documentElement;
    html.classList.add("theme-transition");
    setTheme(prev => {
      const next = prev === "light" ? "dark" : "light";
      if (next === "dark") {
        html.classList.add("dark");
      } else {
        html.classList.remove("dark");
      }
      localStorage.setItem("theme", next);
      return next;
    });
    setTimeout(() => html.classList.remove("theme-transition"), 350);
  }, []);
  return <ThemeContext.Provider value={{
    theme,
    toggleTheme
  }}>
      {children}
    </ThemeContext.Provider>;
}
_s(ThemeProvider, "ee+fyE+Vnmp+FGBROSof+uA6X4A=");
_c = ThemeProvider;
export function useTheme() {
  _s2();
  return useContext(ThemeContext);
}
_s2(useTheme, "gDsCjeeItUuvgOWf1v4qoK9RF6k=");
var _c;
$RefreshReg$(_c, "ThemeProvider");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;